// extracted by mini-css-extract-plugin
export var banner = "_ow-0";
export var settingRow = "_ow-2";
export var titleIcon = "_ow-1";